// extracted by mini-css-extract-plugin
export default {"row":"ImageParametersStyles_row__fEBkg","sizeInput":"ImageParametersStyles_sizeInput__IHXMM"};